import {useCallback, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {fetchDocumentDetail, deleteDocument} from "../services/document-service";

export const useDocumentDetail = ({type, documentId}) => {
    const {loggedCompany} = useSelector((state) => state.user);
    const companyId = loggedCompany?.id;

    const [document, setDocument] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!companyId || !type || !documentId) {
            setDocument(null);
            setIsLoading(false);
            return;
        }

        const controller = new AbortController();
        const signal = controller.signal;

        const loadDetail = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await fetchDocumentDetail({
                    companyId,
                    type,
                    documentId,
                    signal,
                });
                setDocument(response ?? null);
            } catch (err) {
                if (!signal.aborted) {
                    setError(err);
                    setDocument(null);
                }
            } finally {
                if (!signal.aborted) {
                    setIsLoading(false);
                }
            }
        };

        loadDetail();

        return () => controller.abort();
    }, [companyId, documentId, type]);

    const remove = useCallback(async () => {
        if (!companyId || !type || !documentId) {
            throw new Error("Missing parameters to delete document");
        }
        await deleteDocument({companyId, type, documentId});
    }, [companyId, documentId, type]);

    return {
        companyId,
        document,
        isLoading,
        error,
        remove,
    };
};
